import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from "./context/LanguageContext";
import Footer from './components/Footer';
import HomePage from './pages/home_page';
import HomePage_tw from './pages/home_tw_page';
import HomePage_en from './pages/home_en_page';
import HomePage_cn from './pages/home_cn_page';
import Contact from './pages/contact';
import ErrorReturn from './pages/error_return';
import ErrorReturn_en from './pages/error_return_en';
import ErrorReturn_tw from './pages/error_return_tw';
import ErrorReturn_cn from './pages/error_return_cn';
import About from './pages/about';
import Service from './pages/service';
import Feature from './pages/feature';
import Team from './pages/team';
import Partners from './pages/partners'; 
import ApiPage from './pages/api';
import Payment from './pages/payment';
import Disclaimer from './pages/disclaimer';
import Platform from './pages/platform';
import Privacy from './pages/privacy';
import Pricing from './pages/pricing';
import Investors from './pages/investor';
import Video from './pages/video';
import Product_AI from './pages/product_ai';
import Product_LIB from './pages/product_lib';
import Product_Donwload from './pages/product_dowload';
import OutSourcing from './pages/outsourcing';
import Charm from './pages/charm';
function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <main>
            <Routes>
                <Route path="/zh-tw" element={<HomePage_tw />} />
                <Route path="/zh-cn" element={<HomePage_cn />} />
                <Route path="/en" element={<HomePage_en />} />
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<About />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/service" element={<Service />} />
                <Route path="/feature" element={<Feature />} />
                <Route path="/team" element={<Team />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/investors" element={<Investors />} />
                <Route path="/terms_api" element={<ApiPage />} />
                <Route path="/terms_payment" element={<Payment />} />
                <Route path="/terms_disclaimer" element={<Disclaimer />} />
                <Route path="/terms_platform" element={<Platform />} />
                <Route path="/terms_privacy" element={<Privacy />} />
                <Route path="/video" element={<Video />} />
                <Route path="/product_ai" element={<Product_AI />} />
                <Route path="/product_lib" element={<Product_LIB />} />
                <Route path="/product_download" element={<Product_Donwload />} />
                <Route path="/outsourcing" element={<OutSourcing />} />
                <Route path="/error_return" element={<ErrorReturn />} />
                <Route path="/error_return_en" element={<ErrorReturn_en />} />
                <Route path="/error_return_tw" element={<ErrorReturn_tw />} />
                <Route path="/error_return_cn" element={<ErrorReturn_cn />} />
                <Route path="/charm" element={<Charm />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;